module.exports = __webpack_public_path__ + "img/small-gift.f6628ea9.png";